module.exports = __webpack_public_path__ + "static/media/Paciente.d2361e28.jpg";